import { ScreenerResponseStatus } from '@/api/core-api';

/**
 * Where an invited participant is with the task. The response stays INVITED
 * from the invite until autocomplete or the researcher confirms (ATTENDED),
 * so status alone cannot tell "not started", "started" and "complete" apart.
 *
 * Dates are optional in both stages that have one: responses started before
 * core-api recorded `projectStartedAt` have none, and `taskCompletedAt` lives
 * in a free-form task context a partner can overwrite.
 */
export type TaskProgress =
  | { stage: 'notStarted' }
  | { stage: 'started'; startedAt?: string }
  | { stage: 'complete'; completedAt?: string };

/**
 * `null` outside the statuses where a task is in flight: before an invite
 * there is nothing to start, and from ATTENDED on the status says it all.
 */
export function getTaskProgress({
  status,
  projectStarted,
  projectStartedAt,
  isTaskComplete,
  taskCompletedAt,
}: {
  status: ScreenerResponseStatus | null | undefined;
  projectStarted?: boolean;
  projectStartedAt?: string;
  isTaskComplete?: boolean;
  taskCompletedAt?: string;
}): TaskProgress | null {
  if (
    status !== ScreenerResponseStatus.INVITED &&
    status !== ScreenerResponseStatus.SCHEDULED
  ) {
    return null;
  }
  if (isTaskComplete)
    return { stage: 'complete', completedAt: taskCompletedAt };
  if (projectStarted) return { stage: 'started', startedAt: projectStartedAt };
  return { stage: 'notStarted' };
}
